import { faAngleDown, faEnvelope, faPen } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/UI/V3/Button/Button';
import { Dropdown, DropdownContent, DropdownTrigger } from 'components/UI/V3/Dropdown';
import { DropdownItem } from 'components/UI/V3/Dropdown/Item/DropdownItem';
import { FunctionComponent } from 'react';
import styles from './EmailTemplatesEmptyState.module.scss';

interface EmailTemplatesEmptyStateProps {
    onStartWithTemplate: () => void;
    onStartFromScratch: () => void;
}

const EmailTemplatesEmptyState: FunctionComponent<EmailTemplatesEmptyStateProps> = ({
    onStartWithTemplate,
    onStartFromScratch
}) => {
    return (
        <div className={styles.root}>
            <div className={styles.centeredContent}>
                <div className={styles.card}>
                    <div className={styles.iconBadge}>
                        <FontAwesomeIcon
                            icon={faEnvelope}
                            className={styles.icon}
                        />
                    </div>

                    <h3 className={styles.title}>
                        Create a New
                        <br />
                        Email Template
                    </h3>

                    <p className={styles.desktopDescription}>Click the &quot;New Email&quot; button to add one.</p>
                    <p className={styles.mobileDescription}>
                        Email creation is only available on desktop or tablet. Please switch devices to continue.
                    </p>

                    <div className={styles.actions}>
                        <Dropdown>
                            <DropdownTrigger className={styles.primaryButtonTrigger}>
                                <Button
                                    type="button"
                                    size="large"
                                    variant="primary"
                                    className={styles.primaryButton}
                                    label="New Email"
                                    rightIcon={faAngleDown}
                                />
                            </DropdownTrigger>
                            <DropdownContent
                                minWidth={196}
                                align="center"
                            >
                                <DropdownItem
                                    leftIcon={faEnvelope}
                                    onSelect={onStartWithTemplate}
                                >
                                    Start With a Template
                                </DropdownItem>
                                <DropdownItem
                                    leftIcon={faPen}
                                    onSelect={onStartFromScratch}
                                >
                                    Start From Scratch
                                </DropdownItem>
                            </DropdownContent>
                        </Dropdown>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmailTemplatesEmptyState;
